import React from "react";
import styled from "styled-components";

import { Wrapper, Link } from "./styles";

import { nounProjectMenu } from "data/links";

let OverflowMenuDesktop = ({ closeMenu, className, isHeroSearchV2 }) => (
    <Wrapper className={className} isHeroSearchV2={isHeroSearchV2}>
        <ul>
            {nounProjectMenu.map(link => (
                <Link
                    key={link.name}
                    onClick={closeMenu}
                    href={link.href}
                    target={link.external ? "_blank" : "_self"}
                    isHeroSearchV2={isHeroSearchV2}
                >
                    {link.name}
                </Link>
            ))}
        </ul>
    </Wrapper>
);

OverflowMenuDesktop = styled(OverflowMenuDesktop)``;
export { OverflowMenuDesktop };
